import { AuthRepository } from '../repositories/auth_repository';
import { LoginCredentials, LoginResponse } from '../entities/token_entity';

/**
 * Caso de uso para realizar login
 */
export class LoginUseCase {
  constructor(private authRepository: AuthRepository) {}

  async execute(credentials: LoginCredentials): Promise<LoginResponse> {
    try {
      const response = await this.authRepository.login(credentials);
      
      // Extrai expiração do JWT
      const expiresAt = this.extractTokenExpiration(response.token);
      
      // Persiste o token após login bem-sucedido
      await this.authRepository.persistToken({
        token: response.token,
        expiresAt,
        user: response.user
      });

      return response;
    } catch (error) {
      // Propaga a mensagem de erro amigável vinda das camadas inferiores
      if (error instanceof Error && error.message) {
        throw new Error(error.message);
      }
      throw new Error('Erro desconhecido ao realizar login.');
    }
  }

  /**
   * Extrai a data de expiração do token JWT
   */
  private extractTokenExpiration(token: string): Date | undefined {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp ? new Date(payload.exp * 1000) : undefined;
    } catch (error) {
      console.warn('Não foi possível extrair expiração do token:', error);
      return undefined;
    }
  }
}
